import { __read, __spread } from "tslib";
// Will use the shortest indention as an axis
export var freeText = function (text, skipIndentation) {
    if (skipIndentation === void 0) { skipIndentation = false; }
    if (text instanceof Array) {
        text = text.join('');
    }
    // This will allow inline text generation with external functions, same as ctrl+shift+c
    // As long as we surround the inline text with ==>text<==
    text = text.replace(/( *)==>((?:.|\n)*?)<==/g, function (_match, baseIndent, content) {
        return content
            .split('\n')
            .map(function (line) { return "" + baseIndent + line; })
            .join('\n');
    });
    if (skipIndentation) {
        return text;
    }
    var lines = text.split('\n');
    var minIndent = lines
        .filter(function (line) { return line.trim(); })
        .reduce(function (minIndent, line) {
        var currIndent = line.match(/^ */)[0].length;
        return currIndent < minIndent ? currIndent : minIndent;
    }, Infinity);
    return lines
        .map(function (line) { return line.slice(minIndent); })
        .join('\n')
        .trim()
        .replace(/\n +\n/g, '\n\n');
};
// foo_barBaz -> ['foo', 'bar', 'Baz']
export var splitWords = function (str) {
    return str.replace(/[A-Z]/, ' $&').split(/[^a-zA-Z0-9]+/);
};
// upper -> Upper
export var toUpperFirst = function (str) {
    return str.substr(0, 1).toUpperCase() + str.substr(1).toLowerCase();
};
// foo-bar-baz -> fooBarBaz
export var toCamelCase = function (str) {
    var words = splitWords(str);
    var first = words.shift().toLowerCase();
    var rest = words.map(toUpperFirst);
    return __spread([first], rest).join('');
};
//# sourceMappingURL=utils.js.map